function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M355.862 308.172s17.483 8.476 15.485 24.713c-1.146 9.318-14.001 21.686-14.001 21.686s10.981-3.561 16.321-16.446c7.319-17.663-12.117-28.862-17.805-29.953z",
  fill: "#000000",
  "data-original": "#000000",
  className: ""
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M330.944 143.658c.044.775.161 1.53.355 2.254 14.41-3.395 24.832-16.434 27.32-32.316-2.766 13.134-13.922 25.437-27.675 30.062z",
  fill: "#000000",
  "data-original": "#000000",
  className: ""
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 390.956,
  cy: 180.43,
  rx: 10.166,
  ry: 8.275,
  transform: "rotate(-71.451 390.97 180.441)",
  fill: "#000000",
  "data-original": "#000000",
  className: ""
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 351.493,
  cy: 167.187,
  rx: 10.166,
  ry: 8.275,
  transform: "rotate(-71.451 351.505 167.197)",
  fill: "#000000",
  "data-original": "#000000",
  className: ""
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M337.874 232.38c11.251-2.33 21.06-10.361 24.971-22.017 2.28-6.795-1.38-14.152-8.175-16.432-6.794-2.28-14.151 1.38-16.432 8.175-1.3 3.874-5.51 5.969-9.385 4.669s-5.97-5.511-4.67-9.385c2.28-6.795-1.379-14.152-8.174-16.432-6.795-2.28-14.152 1.38-16.432 8.175-2.546 7.587-2.099 15.565.54 22.522l16.297 3.679 2.635 9.98 9.868-1.29 8.957 8.356z",
  fill: "#000000",
  "data-original": "#000000",
  className: ""
});

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 258.986,
    cy: 335.083,
    r: 176.917,
    style: {},
    fill: "#accad2",
    "data-original": "#92dcdd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.351 230.784c-10.882 0-23.293-2.185-34.433-9.482-17.598-11.524-27.33-32.327-28.924-61.832-.351-6.5 4.634-12.056 11.135-12.408 6.502-.338 12.057 4.635 12.408 11.137 1.164 21.538 7.291 36.113 18.21 43.32 17.149 11.326 42.232 2.372 42.484 2.282 6.102-2.231 12.873.893 15.122 6.986 2.248 6.092-.834 12.848-6.918 15.118-.869.324-13.381 4.879-29.084 4.879z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff8b9f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.536 158.186c-.351-6.502-5.906-11.476-12.408-11.137-6.501.352-11.486 5.908-11.135 12.408.238 4.398.679 8.578 1.277 12.587l23.114-4.835a113.48 113.48 0 0 1-.848-9.023z",
    style: {},
    fill: "#252658",
    "data-original": "#4846c2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.223 444.689c-5.672 0-10.653-4.065-11.594-9.838-.213-1.301-4.923-32.397 18.729-80.469 2.875-5.843 9.94-8.251 15.783-5.373 5.842 2.875 8.248 9.94 5.373 15.783-19.997 40.644-16.633 66.118-16.598 66.371.921 6.401-3.48 12.405-9.872 13.386-.613.094-1.222.14-1.821.14z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff8b9f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.176 422.777c-.259 7.387.377 11.613.453 12.075.942 5.772 5.922 9.838 11.594 9.838.6 0 1.209-.046 1.82-.139 6.392-.981 10.793-6.985 9.872-13.386-.012-.085-.395-3.015-.15-8.387h-23.589zM224.67 100.604s-7.497 6.009-11.845 19.166c-4.349 13.157-2.655 21.282-15.079 22.104-12.424.822-7.626-41.021-35.958-32.4-10.298 3.134-18.327 32.069-2.911 51.18-8.232-1.031-13.189 5.386-12.964 13.746.626 23.244 46.959 26.543 50.758 15.222l10.305-30.707s-.952.819-2.551 2.021l20.245-60.332zM318.433 349.978l.332-1.939s5.333 4.236 10.127 7.511c8.308 5.674 17.993-3.895 18.312-13.245.423-12.421-13.718-14.492-6.692-27.043 7.026-12.551 15.351-7.09 15.351-7.09 12.538-21.699 53.726 2.132 41.897 34.387-15.619 42.586-60.771 32.125-79.327 7.419z",
    style: {},
    fill: "#252658",
    "data-original": "#4846c2",
    className: ""
  }), _ref2, /*#__PURE__*/React.createElement("path", {
    d: "m223.127 60.674-4.053 1.782c-10.349 4.551-15.049 16.63-10.498 26.979l17.762 40.39 29.282-12.877-23.149-52.638a7.089 7.089 0 0 0-9.344-3.636z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff8b9f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.33 107.853 270.909 1.831c1.015-3.026 5.522-2.056 5.203 1.119l-11.503 114.58-29.279-9.677z",
    style: {},
    fill: "#d8ae30",
    "data-original": "#fbc900",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m271.551 48.38-12.868-10.118-14.79 44.075 22.572 16.7z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.787 157.791s7.032 10.274 15.331 11.803c8.299 1.529 11.761-1.847 11.761-1.847s-8.66 6.996-17.319 1.499c-7.848-4.98-9.773-11.455-9.773-11.455z",
    style: {},
    fill: "#160521",
    "data-original": "#160521",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.767 160.244 229.976 102.93c-11.417-3.831-23.778 2.318-27.61 13.735l-21.962 65.445-26.368 78.577c-15.351 45.745 9.289 95.273 55.033 110.623l47.12 15.812a25.9 25.9 0 0 0 8.592 1.328l.018.171 15.806-1.661c32.853-3.451 56.689-32.882 53.237-65.735-1.516-14.43-7.028-27.469-15.307-38.152l14.188-42.279-.002-.001.756.254c30.641 10.282 63.815-6.222 74.097-36.862l6.064-18.07c3.591-10.698-2.172-22.281-12.871-25.871z",
    style: {},
    fill: "#ecd8dd",
    "data-original": "#ffb2b9",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.22
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.416 180.044a12.34 12.34 0 0 1-7.564-2.581 1.177 1.177 0 1 1 1.441-1.865c4.382 3.378 10.7 2.574 14.082-1.81a1.177 1.177 0 1 1 1.865 1.441 12.385 12.385 0 0 1-9.824 4.815z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.934 194.254c.26-2.173-.882-4.364-2.822-5.376a5.372 5.372 0 0 0-7.07 1.903c.212-2.42-1.23-4.762-3.635-5.569a5.381 5.381 0 0 0-6.813 3.389c-.013.04-.015.08-.027.12l-.012-.004c-1.217 3.627 2.043 8.254 4.411 10.989a5.547 5.547 0 0 0 5.352 1.813c2.504-.532 5.953-1.551 8.186-3.392 1.269-.822 2.224-2.147 2.43-3.873z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.22
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m332.724 240.795-70.753-23.743 66.775 35.598 3.978-11.855z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.093 99.286s35.2 15.62 68.8 1.317c40.714-17.331 61.115-11.917 64.083.487 2.968 12.404-14.792 37.919-14.792 37.919L219.093 99.286z",
    style: {},
    fill: "#160521",
    "data-original": "#160521",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.103 104.17a25.972 25.972 0 0 0-4.062-11.182c-22.364-34.354-65.493 3.577-88.267 8.823s-34.253-8.973-49.644-5.458c-18.756 4.283-19.505 31.422-16.241 24.715 5.418-11.128 13.066-22.921 51.355-10.629 20.222 6.492 49.253-11.9 70.883-13.681 12.974-1.068 15.646 21.895-7.942 16.229-24.766-5.949-28.22 16.477-17.685 24.725 10.914 8.545 22.922 9.483 33.436 5.949.216 3.813 2.38 7.079 5.22 9.079 10.157 7.155 29.359.621 31.454-18.976 1.633-15.261-5.79-26.169-8.507-29.594z",
    style: {},
    fill: "#252658",
    "data-original": "#4846c2",
    className: ""
  }), _ref3, /*#__PURE__*/React.createElement("path", {
    d: "M402.793 184.402c-1.824 5.435-7.708 8.362-13.143 6.539-5.435-1.824-8.363-7.708-6.539-13.143 1.824-5.435 7.708-8.362 13.143-6.538 5.436 1.822 8.363 7.707 6.539 13.142z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  }), _ref4, /*#__PURE__*/React.createElement("path", {
    d: "M363.33 171.159c-1.824 5.435-7.708 8.362-13.143 6.538-5.435-1.824-8.363-7.708-6.539-13.143 1.824-5.435 7.708-8.362 13.143-6.538 5.435 1.824 8.363 7.708 6.539 13.143z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  }), _ref5, /*#__PURE__*/React.createElement("path", {
    d: "m179.082 77.369-2.855 3.384c-7.29 8.641-6.195 21.556 2.447 28.846l33.724 28.451 20.627-24.449-43.952-37.08a7.092 7.092 0 0 0-9.991.848z",
    style: {},
    fill: "#ecd8dd",
    "data-original": "#ffb2b9",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.22
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.376 106.072c-8.805-7.428-9.942-20.566-2.572-29.401-.29.25-.57.518-.824.821l-2.455 2.91c-7.454 8.836-6.334 22.041 2.501 29.495l33.373 28.155 3.278-3.886-33.301-28.094z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  })), _ref6, /*#__PURE__*/React.createElement("path", {
    d: "M300.038 211.597c3.436 9.014 10.721 16.483 20.558 19.784 5.798 1.946 11.754 2.17 17.349 1.006.158-.339.317-.677.437-1.036 2.624-7.821-4.781-17.359-16.541-21.306-8.417-2.824-16.764-2.003-21.803 1.552z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m178.122 188.915-24.085 71.773c-15.351 45.745 9.288 95.273 55.033 110.623l42.715 14.334c-8.215-11.014-19.608-30.513-13.682-48.171 5.899-17.579 11.906-34.117 11.906-34.117s4.05 8.649 9.505 6.202c8.467-3.798.942-16.617.942-16.617 9.289 4.721 13.43-8.149 6.916-11.048-6.514-2.899-12.579-7.133-9.587-16.051l5.092-14.975c5.642-16.593-3.277-34.612-19.892-40.187l-64.863-21.766z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.192 157.875c-2.058 8.999-11.022 14.626-20.021 12.568s-14.626-11.022-12.567-20.021c2.058-8.999 11.022-14.625 20.021-12.567 8.999 2.057 14.625 11.021 12.567 20.02z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.935 156.901c-1.521 6.648-8.142 10.804-14.79 9.283-6.647-1.52-10.804-8.142-9.283-14.789 1.52-6.647 8.142-10.804 14.789-9.283 6.648 1.52 10.804 8.141 9.284 14.789z",
    style: {},
    fill: "#160521",
    "data-original": "#160521",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.207,
    cy: 157.629,
    r: 3.676,
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.367 371.649c-1.791-5.113-2.353-8.501-2.408-8.853l21.794-3.43c.014.069 2.85 15.581 17.374 29.229 13.771 12.939 35.704 5.708 35.924 5.633 5.75-2.014 12.019 1.023 14.033 6.772 2.014 5.75-1.04 12.053-6.789 14.067-1.404.492-34.662 11.793-58.274-10.395-12.559-11.797-18.737-24.696-21.654-33.023z",
    style: {},
    fill: "#ecd8dd",
    "data-original": "#ffb2b9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.45 395.552c3.365-.585 5.532-1.299 5.6-1.323 5.75-2.014 12.019 1.023 14.033 6.772 2.014 5.75-1.04 12.053-6.789 14.067-.422.148-3.739 1.272-8.795 2.17l-4.049-21.686z",
    style: {},
    fill: "#252658",
    "data-original": "#4846c2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.389 341.846-3.807-.399-.549-2.524c-.203-.936-1.476-1.086-1.891-.223L320 341.071l-5.12-.537c-.951-.1-1.492 1.057-.807 1.723l3.647 3.549-1.122 2.33c-.431.896.558 1.808 1.416 1.306l2.149-1.259 3.795 3.693c.715.696 1.898.039 1.687-.936l-1.151-5.294 3.298-1.931c.84-.49.564-1.768-.403-1.869z",
    style: {},
    fill: "#160521",
    "data-original": "#160521",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.908 341.589-5.011-1.308-.217-3.597c-.063-1.04-1.417-1.395-1.983-.521l-1.96 3.031-2.297-.6c-.993-.259-1.753.884-1.129 1.699l1.472 1.925-2.682 4.149c-.556.86.287 1.938 1.255 1.606l4.619-1.581 1.428 1.868c.647.846 1.998.343 1.934-.72l-.136-2.252 4.785-1.637c1.01-.344.957-1.792-.078-2.062z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.975 321.666-7.449-1.303-.571-3.78c-.223-1.478-2.226-1.774-2.866-.422l-1.576 3.326-7.749-1.355c-1.478-.259-2.392 1.56-1.302 2.592l5.844 5.534-2.427 5.123c-.626 1.322.799 2.676 2.087 1.982l5-2.693 2.775 2.628c1.046.991 2.754.099 2.539-1.326l-.581-3.851 6.736-3.628c1.263-.683.956-2.579-.46-2.827z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.161 279.07c-4.492-3.028-14.531-10.443-24.422-17.562l12.966-18.017c.053.047 31.254 24.933 51.056 27.193 18.774 2.142 32.036-16.765 32.167-16.956 3.406-5.051 10.247-6.364 15.298-2.959 5.052 3.406 6.371 10.284 2.965 15.336-.832 1.233-20.739 30.173-52.932 26.499-17.119-1.953-29.782-8.602-37.098-13.534z",
    style: {},
    fill: "#ecd8dd",
    "data-original": "#ffb2b9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.229 258.135c2.348-2.481 3.658-4.348 3.699-4.408 3.406-5.051 10.247-6.364 15.298-2.959 5.052 3.406 6.371 10.284 2.965 15.336-.25.371-2.237 3.255-5.754 6.997l-16.208-14.966z",
    style: {},
    fill: "#252658",
    "data-original": "#4846c2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.875 204.584-11.095 21.062c-1.597 3.451-1.938 7.404-.715 10.977-2.078 1.618-4.153 3.172-6.239 4.598-2.279 1.473-4.472 2.904-6.674 3.945-2.201 1.02-4.298 1.761-5.954 1.923-1.695.137-2.725-.157-3.373-.965-.687-.781-1.165-1.975-2.224-3.258-9.926-12.029-21.918-9.727-23.334-9.215-2.49.9-4.347 1.87-7.69 5.114-1.179 1.144 2.83.665 5.781 7.744 1.181 2.834 1.843 5.475 3.325 8.025 1.677 2.945 4.081 5.741 7.602 7.841 3.448 2.1 8.176 3.529 13.071 3.731 2.453.096 4.897-.164 7.163-.652 2.237-.556 4.316-1.352 6.085-2.341 3.607-1.936 6.288-4.356 8.474-6.894 2.189-2.532 4.031-5.085 5.61-7.749a86.274 86.274 0 0 0 4.044-7.694c.43.099.84.17 1.178.174 11.149.128 20.15-2.348 20.15-2.348l6.751-26.216-8.104-5.688-8.574-2.809-5.258.695z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.589 244.048 119.724 19.002 5.369-16.385-121.975-39.966zM200.133 203.889l-26.681-8.742-6.918 19.916 3.039 19.489z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.22
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.705 126.876c2.95-.205 4.801-3.326 3.513-5.988-2.642-5.461-8.408-9.051-14.832-8.617-8.444.57-22.719 16.474-14.257 16.321 1.003-.018 17.165-1.132 25.576-1.716z",
    style: {},
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.989 125.078c2.95-.205 4.801-3.326 3.513-5.988-2.642-5.461-8.408-9.051-14.832-8.617-8.444.57-22.719 16.474-14.257 16.321 1.002-.018 17.165-1.133 25.576-1.716z",
    style: {},
    fill: "#252658",
    "data-original": "#4846c2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.665 134.88 1.886-2.769a8.591 8.591 0 0 0-2.265-11.937l-50.592-34.457a8.591 8.591 0 0 0-11.937 2.265l-1.886 2.77-.002-.001c-7.03-4.785-16.652-2.966-21.443 4.071-4.789 7.034-2.963 16.654 4.069 21.441 1.563 1.065 3.282 1.782 5.067 2.215-.738 11.221 3.363 22.49 11.709 30.626L97.049 165.58l-13.139-2.265a5.812 5.812 0 0 0-5.791 2.456l-1.465 2.15a3.21 3.21 0 0 0 .846 4.46l31.696 21.587a3.21 3.21 0 0 0 4.46-.846l1.465-2.15a5.813 5.813 0 0 0 .164-6.288l-6.921-11.397 11.223-16.477c10.619 4.784 22.597 4.476 32.764-.31a15.356 15.356 0 0 0 12.603 6.566c4.937 0 9.795-2.36 12.779-6.739v-.002c4.79-7.036 2.964-16.656-4.068-21.445zm-78.189-24.465c-3.808-2.593-4.796-7.803-2.201-11.614a8.351 8.351 0 0 1 6.921-3.652c1.619 0 3.256.47 4.693 1.446l.001.001-1.65 2.423c-2.654 3.896-4.463 8.108-5.559 12.427-.771-.243-1.52-.562-2.205-1.031zm76.409 41.929c-2.595 3.806-7.803 4.796-11.614 2.201-.686-.466-1.257-1.046-1.765-1.673 3.618-2.602 6.874-5.828 9.527-9.724l1.649-2.422.001.001c3.809 2.594 4.797 7.804 2.202 11.617z",
    style: {},
    fill: "#d8ae30",
    "data-original": "#fbc900",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.22
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.732 178.414h44.769v1.393H73.732z",
    style: {},
    transform: "rotate(34.259 96.123 179.112)",
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.22
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.444 152.797h13.691v2.196h-13.691z",
    style: {},
    transform: "rotate(34.259 113.297 153.895)",
    fill: "#cf5285",
    "data-original": "#ff3482",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.755 106.43a2.819 2.819 0 0 1-.743-3.916l6.874-10.093a2.819 2.819 0 0 1 4.659 3.173l-6.874 10.093a2.818 2.818 0 0 1-3.916.743z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.022 140.07a3.54 3.54 0 0 1-1.053-1.124c-5.978-10.131-4.626-20.443-4.565-20.877a3.538 3.538 0 0 1 3.99-3.016 3.546 3.546 0 0 1 3.017 3.98c-.023.177-1.006 8.427 3.65 16.318a3.537 3.537 0 0 1-5.039 4.719z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.689 119.636-1.389-6.635c-.379-1.809 1.481-3.266 3.147-2.467l6.111 2.934a2.229 2.229 0 0 0 2.074-.076l5.881-3.371c1.603-.919 3.564.399 3.318 2.231l-.901 6.719a2.23 2.23 0 0 0 .713 1.949l5.024 4.552c1.369 1.241.722 3.513-1.096 3.845l-6.669 1.219a2.23 2.23 0 0 0-1.633 1.28L133.493 138c-.757 1.686-3.118 1.772-3.996.146l-3.22-5.965a2.231 2.231 0 0 0-1.722-1.158l-6.74-.729c-1.837-.199-2.649-2.418-1.374-3.755l4.678-4.906a2.227 2.227 0 0 0 .57-1.997z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m126.458 353.44 13.862 5.791-13.862 5.79-5.79 13.862-5.791-13.862-13.862-5.79 13.862-5.791 5.791-13.862zM166.771 400.919l6.774 2.83-6.774 2.829-2.829 6.774-2.83-6.774-6.774-2.829 6.774-2.83 2.83-6.774zM375.53 418.033l6.774 2.829-6.774 2.83-2.83 6.774-2.829-6.774-6.774-2.83 6.774-2.829 2.829-6.774zM307.929 470.43l10.865 4.538-10.865 4.539-4.539 10.865-4.538-10.865-10.865-4.539 10.865-4.538 4.538-10.865z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.29c3280ce2f2c098aa2a4376b4ee1ace.svg";
export { ForwardRef as ReactComponent };